module.exports = __webpack_public_path__ + "img/xia4.c8c2ddeb.png";